export default __webpack_public_path__ + "static/llama-jump-screenshot-340fb80b78e94f4315f92cab03b65586.png";